module.exports = __webpack_public_path__ + "fonts/mem5YaGs126MiZpBA-UN7rgOX-hpOqc.f61100cb.woff2";